"use client";

import Link from "next/link";
import { useRouter } from "next/navigation";
import { useState } from "react";
import { apiPost, startGoogleAuth } from "../components/api";

export default function RegisterPage() {
  const router = useRouter();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const onSubmit = async () => {
    setError(null);
    setLoading(true);
    try {
      const data = await apiPost<{ token: string; refreshToken?: string }>(
        "/v1/auth/register",
        {
          email,
          password,
          displayName: name || undefined
        }
      );
      localStorage.setItem("auth_token", data.token);
      if (data.refreshToken) {
        localStorage.setItem("refresh_token", data.refreshToken);
      }
      router.push("/dashboard");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      <nav className="nav">
        <div className="brand">AudioHawk</div>
        <div className="links">
          <Link href="/">Home</Link>
          <Link href="/login">Login</Link>
        </div>
      </nav>

      <main className="hero">
        <div>
          <div className="section-title">Create Account</div>
          <h1>Set up your operator profile.</h1>
          <p>Use email/password or connect with Google to start managing units.</p>
        </div>

        <div className="card">
          <h2>Register</h2>
          <form
            className="form"
            onSubmit={(event) => {
              event.preventDefault();
              void onSubmit();
            }}
          >
            <div>
              <label>Name</label>
              <input
                type="text"
                placeholder="Avery Chen"
                value={name}
                onChange={(event) => setName(event.target.value)}
              />
            </div>
            <div>
              <label>Email</label>
              <input
                type="email"
                placeholder="name@audiohawk.io"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
            </div>
            <div>
              <label>Password</label>
              <input
                type="password"
                placeholder="Create a strong password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
              />
            </div>
            {error ? <div style={{ color: "var(--muted)" }}>{error}</div> : null}
            <button className="button" type="submit" disabled={loading}>
              {loading ? "Creating..." : "Create Account"}
            </button>
            <button
              className="button secondary"
              type="button"
              onClick={startGoogleAuth}
            >
              Continue with Google
            </button>
          </form>
        </div>
      </main>
    </div>
  );
}
